export const USER_LIST_REQUEST = "USER_LIST_REQUEST";
export const USER_ADD_REQUEST = "USER_ADD_REQUEST";
export const USER_GET_REQUEST = "USER_GET_REQUEST";
export const USER_ACTIVE_DEACTIVE_REQUEST = "USER_ACTIVE_DEACTIVE_REQUEST";
